export const holidays_2025 = [
  "2025-01-01", // año nuevo (miercoles)
  "2025-01-22", // dia del estado plurinacional (miercoles)
  "2025-03-03", // carnaval (lunes)
  "2025-03-04", // carnaval (martes)
  "2025-04-18", // viernes santo
  "2025-05-01", // dia del trabajador(jueves)
  "2025-06-19", // corpus cristi (jueves)
  "2025-06-21", // año nuevo andino (sábado) --> al lunes 23/06
  "2025-08-06", // 6 de agosto(miercoles)
  "2025-11-02", // todos santos (domingo) --> al lunes 03/11
  "2025-11-03", // feriado todos santos (lunes)
  "2025-12-25", // navidad (jueves)
];

export const holidays_2026 = [
  "2026-01-01", // año nuevo (jueves)
  "2026-01-22", // dia del estado plurinacional (jueves)
  "2026-02-16", // carnaval (lunes)
  "2026-02-17", // carnaval (martes)
  "2026-04-03", // viernes santo
  "2026-05-01", // dia del trabajador(viernes)
  "2026-06-04", // corpus cristi (jueves)
  "2026-06-21", // año nuevo andino (domingo) --> al lunes 22/06
  "2026-06-22", // feriado año nuevo andino (lunes)
  "2026-08-06", // 6 de agosto(jueves)
  "2026-11-02", // todos santos (lunes)
  "2026-12-25", // navidad (viernes)
];

export const holidays_2027 = [
  "2027-01-01", // año nuevo (viernes)
  "2027-01-22", // dia del estado plurinacional (viernes)
  "2027-02-08", // carnaval (lunes)
  "2027-02-09", // carnaval (martes)
  "2027-03-26", // viernes santo
  "2027-05-01", // dia del trabajador(sábado) --> al lunes 03/05
  "2027-05-03", // feriado dia del trabajador (lunes)
  "2027-05-27", // corpus cristi (jueves)
  "2027-06-21", // año nuevo andino (lunes)
  "2027-08-06", // 6 de agosto(viernes)
  "2027-11-02", // todos santos (martes)
  "2027-12-25", // navidad (sábado) --> al lunes 27/12
];

export const holidays_2028 = [
  "2028-01-01", // año nuevo (sábado) --> al lunes 03/01
  "2028-01-22", // dia del estado plurinacional (sábado) --> al lunes 24/01
  "2028-01-24", // feriado dia del estado plurinacional (lunes)
  "2028-02-28", // carnaval (lunes)
  "2028-02-29", // carnaval (martes)
  "2028-04-14", // viernes santo
  "2028-05-01", // dia del trabajador(lunes)
  "2028-06-15", // corpus cristi (jueves)
  "2028-06-21", // año nuevo andino (miercoles)
  "2028-08-06", // 6 de agosto(domingo) --> al lunes 07/08
  "2028-08-07", // feriado 6 de agosto (lunes)
  "2028-11-02", // todos santos (jueves)
  "2028-12-25", // navidad (lunes)
];

export const holidays_2029 = [
  "2029-01-01", // año nuevo (lunes)
  "2029-01-22", // dia del estado plurinacional (lunes)
  "2029-02-12", // carnaval (lunes)
  "2029-02-13", // carnaval (martes)
  "2029-03-30", // viernes santo
  "2029-05-01", // dia del trabajador(martes)
  "2029-05-31", // corpus cristi (jueves)
  "2029-06-21", // año nuevo andino (jueves)
  "2029-08-06", // 6 de agosto(lunes)
  "2029-11-02", // todos santos (viernes)
  "2029-12-25", // navidad (martes)
];

export const holidays_2030 = [
  "2030-01-01", // año nuevo (martes)
  "2030-01-22", // dia del estado plurinacional (martes)
  "2030-03-04", // carnaval (lunes)
  "2030-03-05", // carnaval (martes)
  "2030-04-19", // viernes santo
  "2030-05-01", // dia del trabajador(miercoles)
  "2030-06-20", // corpus cristi (jueves)
  "2030-06-21", // año nuevo andino (viernes)
  "2030-08-06", // 6 de agosto(martes)
  "2030-11-02", // todos santos (sábado) --> al lunes 04/11
  "2030-11-04", // feriado todos santos (lunes)
  "2030-12-25", // navidad (miercoles)
];
